export type Patient = {
    firstName: string;
    lastName: string;
    sex: "male" | "female"; // restricts sex to only these two options
    birthday: string; // using string to represent date in YYYY-MM-DD format
    chiefComplain: string;
    allergy: string;
    primaryCareProvider: string;
}

export type PatientWithUserInfo = Patient & {
    institution: string;
    department: string;
}


export const emptyPatientWithUserInfo: PatientWithUserInfo = {
    firstName: "",
    lastName: "",
    sex: "male",
    birthday: "",
    chiefComplain: "",
    allergy: "",
    primaryCareProvider: "",
    institution: "",
    department: ""
}